import { useTheme, AHText, Box, AHInput } from "arkh";
import { useIntl } from "react-intl";
import { useMutation } from "react-relay";
import { graphql } from "relay-runtime";
import { AlertButtons } from "../../../../common/Alert";
import { WebPopup } from "../../../../common/WebPopup";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";
import { TemplateSelectorCreateTemplatePopupMutation } from "./__generated__/TemplateSelectorCreateTemplatePopupMutation.graphql";

export function TemplateSelectorCreateTemplatePopup(props: {
  todoWorkspaceId: string;
  templateName: null | string;
  setTemplateName: (name: string | null) => void;
}) {
  const intl = useIntl();
  const intl_tokens = useIntlTokens();
  const theme = useTheme();

  const [createTemplate] =
    useMutation<TemplateSelectorCreateTemplatePopupMutation>(graphql`
      mutation TemplateSelectorCreateTemplatePopupMutation(
        $todoWorkspaceId: ID!
        $name: String!
      ) {
        todoWorkspace(id: $todoWorkspaceId) {
          createTemplate(name: $name) {
            workspace {
              ...TemplateSelector_workspace
            }
            todoWorkspace {
              ...TemplateSelector_todo
            }
          }
        }
      }
    `);

  return (
    <WebPopup
      onDismiss={() => {
        props.setTemplateName(null);
      }}
    >
      {props.templateName === null ? null : (
        <>
          <AHText type="title">{intl_tokens.CreateNewTemplate}</AHText>
          <AHText type="body" spaceVertical="medium">
            {intl.formatMessage({
              defaultMessage: `Do you want to create a template with current contents, including instructions, priority level, required response, images and files?
  Linked products, deadline, push notification and receivers will note be included in the template.`,
              description: "Workspace Todo Edit New Template Body",
            })}
          </AHText>
          <Box spaceVertical="medium" spaceBottom="large">
            <AHText type="subtitle" spaceBottom="small">
              {intl_tokens.Name}
            </AHText>
            <AHInput
              style={{ backgroundColor: theme.background }}
              defaultStyle
              onChangeText={props.setTemplateName}
              value={props.templateName}
            />
          </Box>
          <AlertButtons
            onPressedButton={() => {
              props.setTemplateName(null);
            }}
            buttons={[
              {
                text: intl_tokens.Cancel,
                style: "cancel",
              },
              {
                text: intl_tokens.Create,
                style: "default",
                onPress: () => {
                  if (props.templateName) {
                    createTemplate({
                      variables: {
                        name: props.templateName,
                        todoWorkspaceId: props.todoWorkspaceId,
                      },
                      onCompleted: () => {},
                    });
                  }
                },
              },
            ]}
          />
        </>
      )}
    </WebPopup>
  );
}
